module.exports = __webpack_public_path__ + "img/Skirt-Back-B1-Da-Fb-Ge-Hc 后背.bae8ea62.png";